module.exports = __webpack_public_path__ + "img/loader.bc43d80a.gif";